import { render } from "./EventsBlock.vue?vue&type=template&id=3a1189a2&scoped=true"
import script from "./EventsBlock.vue?vue&type=script&lang=js"
export * from "./EventsBlock.vue?vue&type=script&lang=js"

import "./EventsBlock.vue?vue&type=style&index=0&id=3a1189a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1189a2"]])

export default __exports__